import {AfterViewInit, Component, OnInit} from '@angular/core';
import {AppConfig} from '../../config/app.config';
import {RequestsService} from 'src/app/services/requests.service';
import {ActivatedRoute} from '@angular/router';
import {SharedService} from '../../services/SharedService';

declare var jQuery: any;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  constructor(public requestsService: RequestsService, public route: ActivatedRoute, public sharedService: SharedService) {
  }

  store_name: string;
  store_logo: string;
  user_role: string;
  submenu: string;
  dashboard_check: boolean = true;
  sell_check: boolean = true;
  items_check: boolean = true;
  inventory_check: boolean = true;
  reporting_check: boolean = true;
  settings_check: boolean = true;
  users_check: boolean = true;
  apps_check: boolean = true;
  active_menu: string;
  active_main_menu: string;
  path: string;
    config: any;
  user_stores_count: any;

  ngOnInit() {

    this.dashboard_check = this.requestsService.CheckMenuPermission(2);
    this.sell_check = this.requestsService.CheckMenuPermission(3);
    this.reporting_check = this.requestsService.CheckMenuPermission(22);
    this.items_check = this.requestsService.CheckMenuPermission(7);
    this.inventory_check = this.requestsService.CheckMenuPermission(17);
    this.users_check = this.requestsService.CheckMenuPermission(28);
    this.settings_check = this.requestsService.CheckMenuPermission(35);
    this.apps_check = this.requestsService.CheckMenuPermission(40);

    var store = JSON.parse(atob(window.localStorage.getItem(btoa('store_data'))));
    var user = JSON.parse(atob(window.localStorage.getItem(btoa('user'))));
    if (window.localStorage.getItem(btoa('store_count')) && window.localStorage.getItem(btoa('store_count')) != 'null') {
      this.user_stores_count = JSON.parse(atob(window.localStorage.getItem(btoa('store_count'))));
    }
    //this.store_logo = AppConfig.AMAZON_S3 + store.store_logo;
    this.store_logo = AppConfig.NT_STORE_ASSETS + store.store_logo;
    this.store_name = store.store_name;
    this.user_role = user.user_role_name;
    this.path = this.route.routeConfig.path;
    this.active_menu = this.path;
    if (this.path == 'close' || this.path == 'customers') {
      this.active_main_menu = 'sell';
    } else if (this.path == 'items' || this.path == 'departments' || this.path == 'categories' || this.path == 'variants-groups' || this.path == 'variants' || this.path == 'modifire-groups' || this.path == 'modifire' || this.path == 'uom' || this.path == 'return' || this.path == 'mass' || this.path == 'count' || this.path == 'vandors' || this.path == 'receive') {
      this.active_main_menu = 'items';
    } else if (this.path == 'receive') {
      // this.active_main_menu = 'inventory';
    } else if (this.path == 'activity' || this.path == 'attendance-report' || this.path == 'inventory-snapshot' || this.path == 'sales' || this.path == 'store-summary' || this.path == 'sale-summary' || this.path == 'transactions' || this.path == 'invoice-refund' || this.path == 'item-refund') {
      this.active_main_menu = 'reporting';
    } else if (this.path == 'users' || this.path == 'devices' || this.path == 'roles' || this.path == 'drivers'  || this.path == 'permission' ) {
      this.active_main_menu = 'users';
    } else if (this.path === 'settings' || this.path === 'tax' || this.path === 'store' || this.path === 'email' || this.path === 'reason' || this.path === 'payment' || this.path === 'promotions' || this.path === 'loyalty'|| this.path === 'denomination'|| this.path === 'printer/groups') {
      this.active_main_menu = 'settings';
    } else if (this.path == 'apps') {
      this.active_main_menu = 'apps';
    }

    // event trigger when store is updated
    this.sharedService.updateStore().subscribe(x => {
      let store = JSON.parse(atob(window.localStorage.getItem(btoa('store_data'))));
      if (store) {
        this.store_logo = AppConfig.NT_STORE_ASSETS + store.store_logo;
        this.store_name = store.store_name;
      }
    });

  }

  ngAfterViewInit() {
    jQuery('.side_menu').click(function () {

      var id = jQuery(this).attr('rel');
      // jQuery( ".main-menu ul li" ).removeClass( "active" );
      // jQuery(this).addClass( "active" );
      jQuery('.submenu').hide();
      jQuery('.sub-menu').css('transform', 'translateX(0)');
      jQuery('#' + id).show();
    });

    jQuery(window).click(function () {
      jQuery('.submenu').hide();
      jQuery('.sub-menu').css('transform', 'translateX(-220px)');
    });

    jQuery('.sub-menu, .main-menu').click(function (event) {
      event.stopPropagation();
    });

  }


}
